import React from "react";
import { A1XBalance } from "../../components/A1XBalance";
import { DashboardCard } from "../../components/DashboardCard";
import { IMAGES } from "../../localConstants/images";
import { Button, Image } from "@heroui/react";
import { useGetAccountInfo } from "../../hooks/sdkDappHooks";

export const Dashboard = () => {
  const { address } = useGetAccountInfo();

  // Function to truncate address
  const truncateAddress = (addr: string) => {
    if (!addr) return "";
    return `${addr.slice(0, 6)}...${addr.slice(-3)}`;
  };

  const handleStakeClick = () => {
    window.open("https://xexchange.com/staking/A1X-0d446d", "_blank");
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {/* Hello Message - Only show when logged in */}
      <div className="flex flex-col gap-2 col-span-full">
        {/* A1X Balance Card - Full width */}
        {address && <A1XBalance />}
      </div>

      {/* Mobile App Card */}
      <DashboardCard
        title="Mobile App"
        subtitle="Gaming"
        backgroundImage={IMAGES.CARD_1}
        actionText="Download now"
        onAction={() =>
          window.open(
            "https://play.google.com/store/apps/details?id=com.bullseye.ainexus&pli=1",
            "_blank"
          )
        }
      >
        <div className="h-32 sm:h-48"></div>
      </DashboardCard>

      {/* Clone Machine Card */}
      <DashboardCard
        title="A1X Clone Machine"
        subtitle="Transform your Socials in AI Agents"
        backgroundImage={IMAGES.CARD_CLONE_MACHINE}
        actionText="Clone your Socials"
        onAction={() => window.open("https://clone.a1x.io/", "_blank")}
      >
        <div className="h-32 sm:h-48"></div>
      </DashboardCard>

      {/* Stake A1X Card */}
      <DashboardCard
        title="Stake A1X"
        subtitle="Currently Staked: 1000 A1X"
        backgroundImage={IMAGES.STAKE_CONTAINER}
        actionText="Stake A1X"
        onAction={handleStakeClick}
      >
        <div className="h-32 sm:h-48"></div>
      </DashboardCard>

      {/* Marketplace Card */}
      <DashboardCard
        title="Marketplace"
        subtitle="Buy In-Game Currency"
        backgroundImage={IMAGES.CURRENCY_CARD}
        actionText="Buy Currency"
        onAction={() => (window.location.href = "/marketplace")}
      >
        <div className="h-32 sm:h-48"></div>
      </DashboardCard>
    </div>
  );
};
